module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('strong', [_c('em', [_vm._v("Blood Relative")])])])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_vm._v("I tossed the cotton pad at the garbage can, but missed. I bent to pick it up. That’s when I noticed a smear of red on the white plastic garbage liner. It looked like . . . blood!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frowning, I shook the edge of the can to shift the contents. A crumpled tissue rolled to one side and I spotted a small plastic bottle labeled "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TRANSPARENT NONDRYING STAGE BLOOD.")]), _vm._v(" It was empty but for a few drops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crouched there on my heels, trying to understand what I was seeing. Stage blood? Why was there an empty bottle of stage blood in our bathroom?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly I flashed back to Kelly’s flushed face and furtive manner as she slipped back into the reception room after the animal-rights protesters were hauled away. The animal-rights protesters who’d been made up with gallons of stage blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Had Kelly had something to do with that protest? It seemed as though nothing else could explain the stage blood in the garbage can.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why on earth would Kelly want to sabotage her own father’s company?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b8099e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 60
// module chunks = 0